import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { appCoordinator } from './AppCoordinator.js';

export function AppCoordinatorProvider({ children }: { children: React.ReactNode }) {
  const nav = useNavigate();
  useEffect(() => {
    const s = appCoordinator.route$.subscribe((p) => nav(p));
    return () => s.unsubscribe();
  }, [nav]);
  return <>{children}</>;
}
